/**
 * @flow
 * @relayHash b700865317953c58ea09fda28ef71bed
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type frontSquareBoxEventDataSubscriptionVariables = {|
  event_id: string,
  current_board_id: string,
|};
export type frontSquareBoxEventDataSubscriptionResponse = {|
  +frontEventData: ?{|
    +event_id: ?string,
    +current_board_id: ?string,
  |}
|};
export type frontSquareBoxEventDataSubscription = {|
  variables: frontSquareBoxEventDataSubscriptionVariables,
  response: frontSquareBoxEventDataSubscriptionResponse,
|};
*/


/*
subscription frontSquareBoxEventDataSubscription(
  $event_id: ID!
  $current_board_id: ID!
) {
  frontEventData(event_id: $event_id, current_board_id: $current_board_id) {
    event_id
    current_board_id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "current_board_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "frontEventData",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "current_board_id",
        "variableName": "current_board_id"
      },
      {
        "kind": "Variable",
        "name": "event_id",
        "variableName": "event_id"
      }
    ],
    "concreteType": "frontSquareBoxEventType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "event_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "current_board_id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "frontSquareBoxEventDataSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "frontSquareBoxEventDataSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "frontSquareBoxEventDataSubscription",
    "id": null,
    "text": "subscription frontSquareBoxEventDataSubscription(\n  $event_id: ID!\n  $current_board_id: ID!\n) {\n  frontEventData(event_id: $event_id, current_board_id: $current_board_id) {\n    event_id\n    current_board_id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'facd0cbdfea3535370f5eac427c982e8';
module.exports = node;
